import { useRef } from 'react'

import { usePathname } from 'next/navigation'

import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider'

import { HEADER_BANNER_HEIGHT } from './constants'

export const useDisableBodyScroll = (enabled = false) => {
    const { isMobile } = useMobileDetect()
    const pathname = usePathname()
    const isInProfilePages = pathname.includes('/profile')

    const shouldDisableScroll = enabled && isMobile
    const scrollPositionRef = useRef<number>()

    const disableScroll = () => {
        if (!shouldDisableScroll) return

        const currentScroll = typeof window !== 'undefined' ? window?.scrollY : 0

        scrollPositionRef.current = currentScroll

        const body = document.body
        body.style.top = `-${currentScroll}px`

        if (isInProfilePages) {
            const profileHeader = document.getElementById('profile-header')
            profileHeader && (profileHeader.style.position = 'fixed')

            const profileHeaderMarginBottom = profileHeader ? parseInt(getComputedStyle(profileHeader).marginBottom) : 0
            const profileHeaderHeight = (profileHeader?.offsetHeight || 0) + profileHeaderMarginBottom

            body.style.paddingTop = `${profileHeaderHeight}px`
        } else if (currentScroll > HEADER_BANNER_HEIGHT) {
            const header = document.getElementById('header')
            header && (header.style.position = 'fixed')

            body.style.paddingTop = `${header?.offsetHeight || 0}px`
        }

        document.body.classList.add('prevent-scroll')
    }

    const enableScroll = () => {
        if (!shouldDisableScroll) return

        const body = document.body
        body.classList.remove('prevent-scroll')
        body.style.paddingTop = ''
        body.style.top = ''

        const header = document.getElementById('header')
        header && (header.style.position = '')

        if (isInProfilePages) {
            const profileHeader = document.getElementById('profile-header')
            profileHeader && (profileHeader.style.position = '')
        }

        typeof window !== 'undefined' &&
            scrollPositionRef.current &&
            window.scrollTo({ top: scrollPositionRef.current })
    }

    return { shouldDisableScroll, disableScroll, enableScroll }
}
